/**
 * Lazy-load skin concern masks from the server after detect-skin returns scores only.
 */
import { generateSkinConditionMask } from './skinAnalysisApi';

const inFlight = new Map();

export async function fetchSkinConcernMask({ sessionId, displayName, appSessionToken }) {
  if (!sessionId || !displayName) return null;
  const cacheKey = `${sessionId}:${displayName}`;
  if (inFlight.has(cacheKey)) return inFlight.get(cacheKey);

  const job = (async () => {
    try {
      const data = await generateSkinConditionMask({
        sessionId,
        condition: displayName,
        appSessionToken,
      });
      if (data?.success && typeof data.mask === 'string' && data.mask) {
        return data.mask;
      }
      return null;
    } catch {
      return null;
    } finally {
      inFlight.delete(cacheKey);
    }
  })();

  inFlight.set(cacheKey, job);
  return job;
}
